import React, { useState } from 'react';


const NavBar = props => {
	const [active, setActive] = useState("");
	const toggle = () => {
		if (active === "")
			setActive('active')
		else
			setActive('')
	}

	const options = {
		breakPoint: '860px',
		headerHeight: '80px',
		menuWidth: '100vw',
		menuBg: '#2f313e',
		textColor: '#fff',
		fontSize: '1.5rem',
		itemBorder: '1px solid #ccc',
		hoverStateBg: '#00000030',
		burgerColor: '#fff'
	}

	style(options)
	

	return <nav data-burger className="Container">
		<div data-burger-list className={active}>
			{ props.links.map(link =>
					<a href={ link.href } onClick={ toggle } key={link.txt}>
						{ link.txt }
					</a>
			) }
		</div>

		<div className={"ts-burger " + active} onClick={ toggle }>
			<div className="line"></div>
		</div>
	</nav>
}

const style = options => {
	const style = document.createElement('style')
	style.innerHTML = `@media (max-width: ${options.breakPoint}) {
		.ts-burger {
		  cursor: pointer;
		  width: 48px;
		  padding: 4px 8px;
		}
		.ts-burger::after,
		.ts-burger::before,
		.ts-burger div {
		  background-color: ${options.burgerColor};
		  border-radius: 3px;
		  content: '';
		  display: block;
		  height: 3px;
		  margin: 12px 0;
		  -webkit-transition: all .2s ease-in-out;
		  transition: all .2s ease-in-out;
		}
		.ts-burger.active::before {
		  -webkit-transform: translateY(10px) rotate(135deg);
				  transform: translateY(10px) rotate(135deg);
		  margin: 7px 0;
		}
		.ts-burger.active::after {
		  -webkit-transform: translateY(-10px) rotate(-135deg);
				  transform: translateY(-10px) rotate(-135deg);
		  margin: 7px 0;
		}
		.ts-burger.active div {
		  -webkit-transform: scale(0);
				  transform: scale(0);
		  margin: 7px 0;
		}
		[data-burger-list] {
		  height: calc(100vh - ${options.headerHeight});
		  width: ${options.menuWidth};
		  position: fixed;
		  right: 0;
		  top: ${options.headerHeight};
		  display: -webkit-box;
		  display: -ms-flexbox;
		  display: flex;
		  -webkit-box-orient: vertical;
		  -webkit-box-direction: normal;
			  -ms-flex-direction: column;
				  flex-direction: column;
		  background: ${options.menuBg};
		  -webkit-transform: translateX(100%);
				  transform: translateX(100%);
		  -webkit-transition: all .4s;
		  transition: all .4s;
		  gap: 0 !important;
		}
		[data-burger-list].active {
		  -webkit-transform: translateX(0);
				  transform: translateX(0);
		}
		[data-burger-list] a {
		  -webkit-box-flex: 1;
			  -ms-flex: 1;
				  flex: 1;
		  color: ${options.textColor};
		  font-size: ${options.fontSize};
		  display: -webkit-box;
		  display: -ms-flexbox;
		  display: flex;
		  -webkit-box-pack: center;
			  -ms-flex-pack: center;
				  justify-content: center;
		  -webkit-box-align: center;
			  -ms-flex-align: center;
				  align-items: center;
		  border-bottom: ${options.itemBorder};
		}
		[data-burger-list] a:hover, [data-burger-list] a:active, [data-burger-list] a:focus {
		  background: ${options.hoverStateBg};
		}
	  }`
	document.documentElement.appendChild(style)
}

export default NavBar